import axios from 'axios';

export default {
  getProjects (sortBy = 'lastModifiedDate', sortDesc = [true], page = 0, itemsPerPage = 10, query = undefined) {
    if (sortBy.length === 0) {
      sortBy = 'lastModifiedDate';
    }

    if (sortDesc.length === 0) {
      sortDesc[0] = true;
    }
    const sortType = sortDesc[0] ? 'desc' : 'asc';

    const pagination = `sort=${sortBy},${sortType}&page=${page}&pageSize=${itemsPerPage}`;
    const queryParam = !query ? '' : `&q=${query}`;
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects?${pagination}${queryParam}`;
    return axios.get(url);
  },

  createProject (project) {
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects`, project);
  },

  getProject (projectId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}`);
  },

  updateProject (project) {
    return axios.put(`${process.env.VUE_APP_RAISON_API_URL}projects/${project.id}`, project);
  },

  deleteProject (projectId) {
    return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}`);
  },

  share (projectId, emails, role) {
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/share`,
      {
        emails: emails,
        role: role
      });
  },

  removeSharingByUsername (projectId, username) {
    return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/share?username=${username}`);
  },

  removeSharingByEmail (projectId, email) {
    return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/share?email=${email}`);
  },


  getSharings(projectId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/share`);
  }
};